module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0033.jpg?v=39ae7453";